import { render, staticRenderFns } from "./DataDumpButton.vue?vue&type=template&id=6881fce0&"
import script from "./DataDumpButton.vue?vue&type=script&lang=ts&"
export * from "./DataDumpButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports